function getIndustry(type) {
  switch (type) {
    case 1:
      return "纺织服装、服饰业";
    case 2:
      return "农副食品加工业";
    case 3:
      return "食品制造业";
    case 4:
      return "酒、饮料和精制茶制造业";
    case 5:
      return "皮革、毛皮、羽毛及其制品和制鞋业";
    case 6:
      return "木材加工和木、竹、藤、棕、草制品业";
    case 7:
      return "家具制造业";
    default:
      return "未知";
  }
}

function getUserStates(type) {
  switch (type) {
    case 0:
      return "删除";
    case 1:
      return "在职";
    case 2:
      return "离职";
    default:
      return "未知";
  }
}
function getUserGender(type) {
  switch (type) {
    case 0:
      return "未知";
    case 1:
      return "男";
    case 2:
      return "女";
    default:
      return "未知";
  }
}
function getBatchStates(type) {
  switch (type) {
    case 0:
      return "未开始";
    case 1:
      return "生产中";
    case 2:
      return "已完工";
    case 3:
      return "已结算";
    default:
      return "未知";
  }
}
function setBatchStates() {
  return [
    {
      value: "",
      label: "全部"
    },
    {
      value: 0,
      label: "未开始"
    },
    {
      value: 1,
      label: "生产中"
    },
    {
      value: 2,
      label: "已完工"
    }
  ];
}

function getEnterpriseStates(type) {
  switch (type) {
    case 0:
      return "删除";
    case 1:
      return "正常";
    case 2:
      return "已到期";
    default:
      return "未知";
  }
}
function setCheckState() {
  return [
    {
      value: "",
      label: "全部"
    },
    {
      value: 0,
      label: "未确认"
    },
    {
      value: 1,
      label: "已确认"
    }
  ];
}
function getCheckState(type) {
  switch (type) {
    case 0:
      return "未确认";
    case 1:
      return "已确认";
    default:
      return "未知";
  }
}
export {
  getIndustry,
  getUserStates,
  getUserGender,
  getBatchStates,
  setBatchStates,
  getEnterpriseStates,
  setCheckState,
  getCheckState
};
